// extracted by mini-css-extract-plugin
export default {"desktopWrapper":"PasswordChangePage_desktopWrapper__ypYjl","title":"PasswordChangePage_title__puX85","back":"PasswordChangePage_back__aAB+w"};